import { z } from 'zod';

import { Ids } from './schemas';

export const SearchParams = z.object({
    q: z.string().optional(),
    tenantIds: Ids.nullish(),
    userIds: Ids.nullish(),
    contentStatus: z.union([z.string(), z.array(z.string())]).optional(),
    publicationStatus: z.union([z.string(), z.array(z.string())]).optional(),
    tagIds: Ids.optional(),
    categoryIds: Ids.optional(),
    contentType: z.union([z.string(), z.array(z.string())]).nullish(),
});
export type SearchParams = z.infer<typeof SearchParams>;

export const SemanticSearchParams = z.object({
    semanticSearchEnabled: z.boolean().optional(),
    k: z.number().optional(),
    kCandidates: z.number().optional(),
    kSimilarity: z.number().optional(),
});
export type SemanticSearchParams = z.infer<typeof SemanticSearchParams>;

export const PaginationParams = z.object({
    page: z.coerce.number().optional(),
    size: z.coerce.number().optional(),
    sort: z.string().nullish(),
});

export type PaginationParams = z.infer<typeof PaginationParams>;
